export const languageOptions = [
  {
    label: "自动",
    value: "multilingual",
  },
  {
    label: "普通话及方言",
    value: "cn",
  },
  {
    label: "粤语",
    value: "yue",
  },
  {
    label: "英语",
    value: "en",
  },
  {
    label: "日语",
    value: "ja",
  },
  {
    label: "韩语",
    value: "ko",
  },
];

export const translateLanguageOptions = [
  {
    label: "中文",
    value: "cn",
  },
  {
    label: "英语",
    value: "en",
  },
  {
    label: "日语",
    value: "ja",
  },
  {
    label: "韩语",
    value: "ko",
  },
  {
    label: "德语",
    value: "de",
  },
  {
    label: "法语",
    value: "fr",
  },
  {
    label: "俄语",
    value: "ru",
  },
];
